import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { useMutation } from '@apollo/react-hooks';
import styled from 'styled-components';
import ContextSnackbar from 'Components/Snackbar';
import { HeadingTwo } from 'Components/Headings';
import { SnackbarContext } from 'Store/SnackbarContext';
import { UserContext } from 'Store/UserContext';
import { subRouteCodes as SUB_ROUTES } from 'Constants/routes';
import { CREATE_DISCOUNT_CODE } from 'Mutations/Admin/DiscountCodes';
import DiscountCodeForm from 'Components/DiscountCodes/DiscountCodeForm';
import { displayFlex } from '../../../styles/Mixins';
import { paragraphReg } from '../../../styles/Typography';
import colors from '../../../styles/Colors';

const PageContainer = styled.div`
  &&& {
    ${displayFlex}
    align-items: center;
    width: 100%;
    height: auto;
    padding: 12px 0 11px 20px;
    ${paragraphReg}
    font-size: 14px;
    text-align: left;
    background-color: ${colors.background.primary};
    color: ${colors.text};
    border-radius: 3px;
  }
`;

const PageHeader = styled.div`
  text-align: left;
  width: 100%;
  border-bottom: 1px solid rgb(200, 214, 229);
  &&& {
    margin: 65px 0 25px;
  }
`;

const HeaderWrapper = styled.div`
  margin: 20px 0px !important;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const PageBody = styled.div`
  text-align: left;
  width: 100%;
  &&& {
    margin: 0;
    padding: 20px;
  }
`;

const CreateDiscountCode = () => {
  const { showSnackbar } = useContext(SnackbarContext);
  const { user } = useContext(UserContext);
  const venue = user?.venues && user.venues[0];
  const history = useHistory();

  const [createDiscountCode, { loading: createLoading }] = useMutation(CREATE_DISCOUNT_CODE, {
    onCompleted: data => {
      if (data.createDiscountCode.success) {
        showSnackbar(`Discount code "${data.createDiscountCode.discountCode.code}" created successfully`, { error: false, duration: 5000 });
        history.push(SUB_ROUTES.ADMIN.DISCOUNT_CODES);
      } else {
        showSnackbar(data.createDiscountCode.error || 'Unable to create discount code', { error: true, duration: 5000 });
      }
    },
    onError: error => {
      showSnackbar(error?.message?.replace('GraphQL error: ', '') || 'Unable to create discount code', { error: true, duration: 5000 });
    }
  });

  const handleSubmit = async values => {
    // Prepare the input for the mutation
    // Note: venueId comes from context, not from the form
    const input = {
      code: values.code,
      discountType: values.discountType,
      discountPercentage: values.discountType === 'percentage' ? values.discountPercentage : null,
      discountAmount: values.discountType === 'fixed_amount' ? values.discountAmount : null,
      validFrom: values.validFrom,
      validUntil: values.validUntil,
      maxUses: values.maxUses || null,
      minOrderAmount: values.minOrderAmount || null,
      description: values.description || null
    };

    await createDiscountCode({
      variables: { input }
    });
  };

  const handleCancel = () => {
    history.push(SUB_ROUTES.ADMIN.DISCOUNT_CODES);
  };

  return (
    <>
      <PageContainer>
        <ContextSnackbar />
        <PageHeader>
          <HeaderWrapper>
            <HeadingTwo label="CREATE DISCOUNT CODE" />
          </HeaderWrapper>
        </PageHeader>
      </PageContainer>

      <PageBody>
        <DiscountCodeForm onSubmit={handleSubmit} onCancel={handleCancel} loading={createLoading} submitText="CREATE DISCOUNT CODE" showVenueSelector={false} />
      </PageBody>
    </>
  );
};

export default CreateDiscountCode;
